
import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { filter, map } from 'rxjs/operators';
interface IEvent {
    type: string;
    payload?: any;
}
type EventCallback = (payload: any) => void;
@Injectable({
    providedIn: 'root'
})
export class EventService {
    private readonly handler = new Subject<IEvent>();

    /**
     * Broadcast the event
     * @param type type of event
     * @param payload payload
     */
    broadcast(type: string, payload = {}): void {
        this.handler.next({ type, payload });
    }
    /**
     * Subscribe to event
     * @param type type of event
     * @param callback call back function
     */
    subscribe(type: string, callback: EventCallback): Subscription {
        return this.handler.pipe(
            filter(event => event.type === type)).pipe(
                map(event => event.payload))
            .subscribe(callback);
    }
    /**
     * Subscribe to event
     * @param type type of event
     * @param callback call back function
     */
    getEvent(type: string): Observable<IEvent> {
        return this.handler.pipe(
            filter(event => event.type === type)).pipe(
                map(event => event.payload));
    }
}
